module.exports = __webpack_public_path__ + "img/areq1.bb59b493.jpg";